import styled, {css} from 'styled-components';
import {device} from '../../styled/device';
import Input from '../Input';
import Select from '../Select';
import {ErrorMessage as BaseErrorMessage} from '../../styled/common';
import {Label as BaseLabel} from '../Input/styled';

export const Label = styled(BaseLabel)``;

type WrapperProps = {
  disabled?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  /* min-width: min-content; */
  min-height: 56px;

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;

      & ${Label} {
        opacity: 0.3;
      }
    `};

  @media (max-width: ${device.mobileM}) {
    /* min-width: min-content; */
  }
`;

export const FieldsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  position: relative;
  align-items: center;
`;

export const DayInput = styled(Input)`
  min-width: 50px;
  min-height: 36px;
  max-width: 60px;
  max-height: 50px;
  margin-bottom: 15px;

  & input {
    padding-right: 5px;
  }

  & ${BaseLabel} {
    display: none;
  }
`;

export const DateInput = styled(Input)`
  width: 75px;
  min-width: 75px;
  min-height: 36px;
  max-height: 50px;
  margin-bottom: 15px;

  & input {
    padding-right: 5px;
  }

  & ${BaseLabel} {
    display: none;
  }
`;

export const DateSelectWrapper = styled.div`
  display: inline-block;
  position: relative;
  /* margin-bottom: 15px; */
  width: 100%;
  min-width: 115px;
`;

export const DateSelect = styled(Select)`
  display: flex;
  flex-grow: 1;
  width: 100%;
  min-height: 36px;
  max-height: 50px;
  min-width: 0;
  margin-bottom: 15px;

  & .select__value-container {
    padding-bottom: 0 !important;
  }

  & .select__value-container > div {
    margin: 0 !important;
  }

  & .select__input {
    padding-top: 3px !important;
  }

  & .select__input input {
    width: 100px !important;
  }

  & .select__input {
    top: -4px !important;
  }

  & .select__menu,
  & .select__menu-list {
    /* width: 225px !important; */
  }

  & .select__option {
    text-transform: capitalize;
  }

  & .select__control {
    min-height: unset !important;
  }

  @media (max-width: ${device.mobileM}) {
    /* width: 130px; */
  }
`;

export const ErrorMessage = styled(BaseErrorMessage)`
  padding-top: 1px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;
